//-----------------------------------------------------
// -header
//-----------------------------------------------------
export var header = function() {
	$(document).on('click', '.menu_btn', function(a) {
		a.preventDefault();
		$('.menu_btn').toggleClass('active');
	});
};
export var headerResize = function() {
	$('.menu_btn').removeClass('active');
};
